<ng-container *transloco="let t;">

  <ng-container *ngIf="settings.visible === true">
    <h2 *ngIf="title">{{ title }}</h2>
    <div class="p-grid">
      <div class="p-col-fixed" style="width:40px">
        <button type="button" pButton (click)="onOpenEmployeeSearch()" [disabled]="disabled" icon="pi pi-search" class="p-button-secondary p-button-outlined"></button>
      </div>
      <div class="p-col">
        <app-form-control [cid]="'firstname'" [control]="subForm.get('firstname')" [type]="'input'" [label]="t('common.labels.firstname')"></app-form-control>
      </div>
      <div class="p-col">
        <app-form-control [cid]="'lastname'" [control]="subForm.get('lastname')" [type]="'input'" [label]="t('common.labels.lastname')"></app-form-control>
      </div>
      <div class="p-col">
        <app-form-control [cid]="'email'" [control]="subForm.get('email')" [type]="'input'" [label]="wcSpecial === false ? t('common.labels.email') : t('common.labels.email_function_inbox')"></app-form-control>
      </div>
      <div class="p-col">
        <app-form-control [cid]="'mobile'" [control]="subForm.get('mobile')" [type]="'input'" [label]="t('common.labels.mobile')"></app-form-control>
      </div>
    </div>

    <app-employee-search #employeesearch (select)="onSelectEmployee($event)"></app-employee-search>
  </ng-container>

</ng-container>
